export const FETCHING_LOGISTIC_MODELS = '@@toyota/FETCHING_LOGISTIC_MODELS';
export const FETCHED_LOGISTIC_MODELS = '@@toyota/FETCHED_LOGISTIC_MODELS';
export const FETCHED_LOGISTIC_MODELS_FAILED = '@@toyota/FETCHED_LOGISTIC_MODELS_FAILED';
export const FETCHING_LOGISTIC_MODEL_TASKS = '@@toyota/FETCHING_LOGISTIC_MODEL_TASKS';
export const FETCHED_LOGISTIC_MODEL_TASKS = '@@toyota/FETCHED_LOGISTIC_MODEL_TASKS';
export const FETCHED_LOGISTIC_MODEL_TASKS_FAILED = '@@toyota/FETCHED_LOGISTIC_MODEL_TASKS_FAILED';
export const FETCHING_TARGET_LOGISTIC_MODEL_TASKS = '@@toyota/FETCHING_TARGET_LOGISTIC_MODEL_TASKS';
export const FETCHED_TARGET_LOGISTIC_MODEL_TASKS = '@@toyota/FETCHED_TARGET_LOGISTIC_MODEL_TASKS';
export const FETCHED_TARGET_LOGISTIC_MODEL_TASKS_FAILED = '@@toyota/FETCHED_TARGET_LOGISTIC_MODEL_TASKS_FAILED';
export const CLEAN_TARGET_LOGISTIC_MODEL_TASKS = '@@toyota/CLEAN_TARGET_LOGISTIC_MODEL_TASKS';
export const UPDATING_LOGISTIC_MODEL_TASKS = '@@toyota/UPDATING_LOGISTIC_MODEL_TASKS';
export const UPDATED_LOGISTIC_MODEL_TASKS = '@@toyota/UPDATED_LOGISTIC_MODEL_TASKS';
export const UPDATED_LOGISTIC_MODEL_TASKS_FAILED = '@@toyota/UPDATED_LOGISTIC_MODEL_TASKS_FAILED';
export const UPDATING_LOGISTIC_MODEL = '@@toyota/UPDATING_LOGISTIC_MODEL';
export const UPDATED_LOGISTIC_MODEL = '@@toyota/UPDATED_LOGISTIC_MODEL';
export const UPDATED_LOGISTIC_MODEL_FAILED = '@@toyota/UPDATED_LOGISTIC_MODEL_FAILED';

